import { orderMockStore } from './mock-orders';
import { request, API_ENDPOINTS, USE_MOCK } from './config';
import type {
  OrderListQuery,
  OrderListResponse,
  OrderRecord,
  CreateOrderRequest,
  CreateOrderResponse,
  UpdateOrderRequest,
  UpdateOrderResponse,
  DeleteOrderResponse,
} from '@client/src/types/order';

function delay<T>(value: T, ms = 300): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}

/**
 * 订单列表
 * TODO: 对接真实后端时，确认返回结构与 OrderListResponse 一致
 */
export async function getOrders(
  params: OrderListQuery,
): Promise<OrderListResponse> {
  if (USE_MOCK) {
    return delay(orderMockStore.list(params));
  }
  const response = await request.get<OrderListResponse>(
    API_ENDPOINTS.orders.list.path,
    { params },
  );
  return response.data;
}

/**
 * 订单详情
 * TODO: 对接真实后端时，确认路径参数与返回结构
 */
export async function getOrderById(id: string): Promise<OrderRecord> {
  if (USE_MOCK) {
    const order = orderMockStore.getById(id);
    if (!order) throw new Error('订单不存在');
    return delay(order);
  }
  const response = await request.get<OrderRecord>(
    API_ENDPOINTS.orders.getById.path.replace(':id', id),
  );
  return response.data;
}

/**
 * 创建订单
 * TODO: 对接真实后端时，确认请求体结构与返回结构
 */
export async function createOrder(
  data: CreateOrderRequest,
): Promise<CreateOrderResponse> {
  if (USE_MOCK) {
    return delay(orderMockStore.create(data));
  }
  const response = await request.post<CreateOrderResponse>(
    API_ENDPOINTS.orders.create.path,
    data,
  );
  return response.data;
}

/**
 * 更新订单
 * TODO: 对接真实后端时，确认请求体结构与返回结构
 */
export async function updateOrder(
  id: string,
  data: UpdateOrderRequest,
): Promise<UpdateOrderResponse> {
  if (USE_MOCK) {
    return delay(orderMockStore.update(id, data));
  }
  const response = await request.patch<UpdateOrderResponse>(
    API_ENDPOINTS.orders.update.path.replace(':id', id),
    data,
  );
  return response.data;
}

/**
 * 删除订单
 * TODO: 对接真实后端时，确认返回结构
 */
export async function deleteOrder(
  id: string,
): Promise<DeleteOrderResponse> {
  if (USE_MOCK) {
    return delay(orderMockStore.remove(id));
  }
  const response = await request.delete<DeleteOrderResponse>(
    API_ENDPOINTS.orders.remove.path.replace(':id', id),
  );
  return response.data;
}

// 上传图片
export async function uploadImage(
  formData: FormData,
): Promise<{ url: string }> {
  if (USE_MOCK) {
    return delay({ url: 'https://example.com/image.jpg' });
  }
  const response = await request.post<{ url: string }>(
    API_ENDPOINTS.orders.upload.path,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
}